import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsRouterPluginModule, RouterState, RouterStateSerializer } from '@ngxs/router-plugin';

import { NgxsModule } from '@ngxs/store';

import { RouterNavState } from './router-nav.state';
import { RouterNavStateSerializer } from './router-nav-state.serializer';

@Injectable()
// @ts-ignore
export class ApolloRouterState extends RouterState {
  checkInitialNavigationOnce(): void {
    return;
  }
}

@NgModule({
  imports: [NgxsRouterPluginModule.forRoot(), NgxsModule.forFeature([RouterNavState])],
})
export class RouterNavStateModule {
  static forRoot(): ModuleWithProviders<RouterNavStateModule> {
    return {
      ngModule: RouterNavStateModule,
      providers: [
        { provide: RouterStateSerializer, useClass: RouterNavStateSerializer },
        { provide: RouterState, useClass: ApolloRouterState },
      ],
    };
  }
}
